import * as React from 'react';
import { connect } from 'react-redux';
import { ZemplinLoaderWrapper, TitleH2 } from '@bart.sk-eshop/eshop-defaults';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from '@bart.sk-eshop/react-i18n';
import SliderComponent from '../../components/_helpers/Slider/Slider';
import {
  addItemToCart,
  setAddToCartModalVisibility,
  cartUpsellSelector,
  cartUpsellIsFetchingSelector,
} from './cartSlice';

interface Props {
  products: any[] | null;
  isFetching: boolean;
  dispatch: any;
}

function CartUpsell({ products, isFetching, dispatch }: Props) {
  if (!products || (products.length === 0 && !isFetching)) {
    return null;
  }

  const addToCart = (product: any) => {
    dispatch(addItemToCart(product, 1, false, true));
  };

  const addToRequest = (product: any) => {
    dispatch(setAddToCartModalVisibility(true, product));
  };

  return (
    <UpsellSection>
      <StyledTitleH2>{__('Mohlo by vás zaujímať')}</StyledTitleH2>
      {isFetching ? (
        <ZemplinLoaderWrapper height={200} />
      ) : (
        <SliderComponent
          type="cart-upsell"
          slides={products}
          addToCart={addToCart}
          addToRequest={addToRequest}
        />
      )}
    </UpsellSection>
  );
}

const UpsellSection = styled.div`
  display: block;
  width: 100%;
  margin-top: ${rem(48)};
  margin-bottom: ${rem(32)};
`;

const StyledTitleH2 = styled(TitleH2)`
  margin-bottom: ${rem(24)};
`;

const mapStateToProps = state => ({
  products: cartUpsellSelector(state),
  isFetching: cartUpsellIsFetchingSelector(state),
});

export default connect(mapStateToProps)(CartUpsell);
